import { EntityUserRoleEnum } from "@scrinz/dtos";
export function getRoleName(role) {
    switch (role) {
        case EntityUserRoleEnum.Administrator:
            return "Administrator";
        case EntityUserRoleEnum.Moderator:
            return "Moderator";
        case EntityUserRoleEnum.Owner:
            return "Owner";
        default:
            return null;
    }
}
//# sourceMappingURL=get-role-name.js.map